var React = require('react');

function Opening5 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"linear-gradient","x1":"-0.0526","y1":"653.8779","x2":"442.1","y2":"653.8779","gradientTransform":"matrix(1, 0, 0, -1, 0, 1264)","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0","stopColor":"#efa539","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#f5a637","key":1})])),React.createElement("title",{"key":1},"opening-5"),React.createElement("path",{"d":"M442.1,590.5S416,469.2,410.6,463,289.6,34.7,139.4,144.3s-208.6,905.6-24.2,946.9c184.5,41.4,295.4-373.8,295.4-373.8Z","style":{"fill":"url(#linear-gradient)"},"key":2})]);
}

Opening5.defaultProps = {"id":"Layer_1","data-name":"Layer 1","width":"1901.6","height":"1263.9","viewBox":"0 0 1901.6 1263.9"};

module.exports = Opening5;

Opening5.default = Opening5;
